import { Injectable } from '@angular/core';

import { OrgaoNavigationService } from "../../shared/orgao-navigation.service";
import { OrgaoService } from "../../shared/orgao.service";
import { AutoCompleteService } from "../../../../shared/components/autocomplete/autocomplete.service";
import { orgaoTiposStorage } from "./data.service";
import { orgaosStorage } from "../../shared/data.service";

@Injectable()
export class OrgaoTipoService {

  constructor(
    private _orgaoNavigationService: OrgaoNavigationService,
    private _orgaoService: OrgaoService,    

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(orgaoTiposStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(orgaoTiposStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(orgaoTiposStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === orgaosStorage) {
        otherFormObject = this._orgaoService.getSessionStorage();
        otherFormObject.tipoOrgao = Response;
        this._orgaoService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(orgaoTiposStorage);

    if (otherForm === orgaosStorage) {
      otherFormObject = this._orgaoService.getSessionStorage();
      if (otherFormObject.id) {
        this._orgaoNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._orgaoNavigationService.goToNew();
      }
    }
  }

  templateResult = (function(state: any, isCreateNew: boolean) {
    var stateReturn: any,
      text: string;

    if (state.loading) {
      stateReturn = state.text;
    } else {
      if (state.id === -1) {
        if (isCreateNew) {
          stateReturn = this._autocompleteService.setNewTagInList(state);
        } else {
          stateReturn = this._autocompleteService.setNoCreateNew(state.text);
        }
      } else {
        if (state.text) {
          text = state.text;
        } else {
          text = this.templateText(state);
        }
        stateReturn = $('<span>' + text + '</span>');
      }
    }

    return stateReturn;
  }.bind(this));
  
  
  templateText(item: any) {
    var id: string = '',
      text: string = '',
      estado: string = '';
    
    if (item.codigoTCE) {
      id = item.codigoTCE;
      text = id + " - ";
    }
    
    if (item.estado) {
      estado = " (" + item.estado.nome + ")";
    }

    text = text.concat(item.descricao).concat(estado);
    
    return text;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/shared/orgao.service.ts
 **/